import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const notification = apiUrl + "/notification";
const routes = {
  label: "Notification",
  root: notification,
  get_mine: notification + "/get_mine",
  read: notification + "/read",
  unread: notification + "/unread",
  has_mine_unread: notification + "/has_mine_unread",
  count_mine_unread: notification + "/count_mine_unread",
};

export const Notification = {
  get_mine: () => postWithToken(routes.get_mine),
  read: (ids) => postWithToken(routes.read, { ids }),
  has_mine_unread: () => postWithToken(routes.has_mine_unread),
  count_mine_unread: () => postWithToken(routes.count_mine_unread),
};
